import { c as _c } from "react/compiler-runtime";
import { FormSummary, VStack } from "@navikt/ds-react";
import { useRegistreringContextState } from "@/app/(registrering)/state/contextState";
import { formatFnr } from "@/utils/formatting";
import { UiSelector } from "@/utils/uiSelectors";
export function Summary() {
  const $ = _c(49);
  const {
    submittedData,
    handleEdit
  } = useRegistreringContextState();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <FormSummary.Header><FormSummary.Heading level="3">Sykmeldt</FormSummary.Heading></FormSummary.Header>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FormSummary.Label>Fødselsnummer</FormSummary.Label>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== submittedData.sykmeldt.fodselsnummer) {
    t2 = formatFnr(submittedData.sykmeldt.fodselsnummer);
    $[2] = submittedData.sykmeldt.fodselsnummer;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <FormSummary.Answer>{t1}<FormSummary.Value>{t2}</FormSummary.Value></FormSummary.Answer>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FormSummary.Label>Etternavn</FormSummary.Label>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== submittedData.sykmeldt.etternavn) {
    t5 = <FormSummary.Answer>{t4}<FormSummary.Value>{submittedData.sykmeldt.etternavn}</FormSummary.Value></FormSummary.Answer>;
    $[7] = submittedData.sykmeldt.etternavn;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FormSummary.Label>Organisasjonsnummer</FormSummary.Label>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== submittedData.sykmeldt.orgnummer) {
    t7 = <FormSummary.Answer>{t6}<FormSummary.Value>{submittedData.sykmeldt.orgnummer}</FormSummary.Value></FormSummary.Answer>;
    $[10] = submittedData.sykmeldt.orgnummer;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t5 || $[14] !== t7) {
    t8 = <FormSummary.Answers>{t3}{t5}{t7}</FormSummary.Answers>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== handleEdit) {
    t9 = <FormSummary.Footer><FormSummary.EditLink onClick={handleEdit} className="cursor-pointer" /></FormSummary.Footer>;
    $[16] = handleEdit;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <FormSummary data-testid={UiSelector.RegistreringSummary}>{t0}{t8}{t9}</FormSummary>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <FormSummary.Header><FormSummary.Heading level="3">Nærmeste leder</FormSummary.Heading></FormSummary.Header>;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <FormSummary.Label>Fødselsnummer</FormSummary.Label>;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== submittedData.leder.fodselsnummer) {
    t13 = formatFnr(submittedData.leder.fodselsnummer);
    $[23] = submittedData.leder.fodselsnummer;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t13) {
    t14 = <FormSummary.Answer>{t12}<FormSummary.Value>{t13}</FormSummary.Value></FormSummary.Answer>;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <FormSummary.Label>Etternavn</FormSummary.Label>;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== submittedData.leder.etternavn) {
    t16 = <FormSummary.Answer>{t15}<FormSummary.Value>{submittedData.leder.etternavn}</FormSummary.Value></FormSummary.Answer>;
    $[28] = submittedData.leder.etternavn;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <FormSummary.Label>Epost</FormSummary.Label>;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== submittedData.leder.epost) {
    t18 = <FormSummary.Answer>{t17}<FormSummary.Value>{submittedData.leder.epost}</FormSummary.Value></FormSummary.Answer>;
    $[31] = submittedData.leder.epost;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <FormSummary.Label>Mobilnummer</FormSummary.Label>;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== submittedData.leder.mobilnummer) {
    t20 = <FormSummary.Answer>{t19}<FormSummary.Value>{submittedData.leder.mobilnummer}</FormSummary.Value></FormSummary.Answer>;
    $[34] = submittedData.leder.mobilnummer;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t14 || $[37] !== t16 || $[38] !== t18 || $[39] !== t20) {
    t21 = <FormSummary.Answers>{t14}{t16}{t18}{t20}</FormSummary.Answers>;
    $[36] = t14;
    $[37] = t16;
    $[38] = t18;
    $[39] = t20;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== handleEdit) {
    t22 = <FormSummary.Footer><FormSummary.EditLink onClick={handleEdit} className="cursor-pointer" /></FormSummary.Footer>;
    $[41] = handleEdit;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t21 || $[44] !== t22) {
    t23 = <FormSummary>{t11}{t21}{t22}</FormSummary>;
    $[43] = t21;
    $[44] = t22;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== t10 || $[47] !== t23) {
    t24 = <VStack gap="space-32">{t10}{t23}</VStack>;
    $[46] = t10;
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  return t24;
}